import { showNotification } from '../../../../../common/actionCreators/dispatchNotification';
import apiClient from '../../../../../common/api/apiClient';
import { GroupLoginDto } from './login.dtos';

// endpoints
const loginUrl = '/account/groupVisitLogin/';

export const groupLoginApi = async (creds: GroupLoginDto) => {
  return await apiClient.post(loginUrl, creds)
    .then((res) => {
      return res.data.result;
    })
    .catch((err) => {
      if (err && err.response) {
        showNotification(err.response.data, 'error')
      }
      else {
        showNotification('An error occurred while logging in.', 'error');
      }
      throw err;
    });
};